<template>
    <div>
        <!-- <img src="../../../../src/assets/images/index/search.png" alt="" class="search"> -->
        <div class="header">
            <img src="../../../../src/assets/images/index/mobielogo.png" alt="" class="logo">
            <img src="../../../../src/assets/images/index/navigation.png" alt="" class="nav" @click="drawerEvent">
        </div>
        <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            size="80%"
        >
            <el-menu
                :default-active="active"
                class="el-menu-vertical-demo"
                :collapse="isCollapse"
                @select="select"
            >
                <div v-for="(item,index) in list" :key="index">
                    <el-submenu v-if="item.arr" :index="item.index">
                        <template slot="title">
                            <span>{{ item.name }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="(arrItem,arrIndex) in item.arr" :key="arrIndex" :index="`${item.index}-${arrItem.index}`">{{ arrItem.name }}</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item v-else :index="item.index">
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </div>
            </el-menu>
        </el-drawer>
    </div>
</template>

<script>
export default {
    props: ['activity'],
    data() {
        return {
            drawer: false,
            isCollapse: false,
            direction: 'ltr',
            active: '1',
            state: 0,
            list: [
                {name: '首页', index: '1', routerName: 'index'},
                {name: '新闻中心', index: '2', routerName: 'Policies', cId: '1'},
                {
                    name: 'CMCA介绍',
                    index: '3',
                    arr: [
                        {name: '中国移动通信联合会简介', index: '1', routerName: 'synopsis'},
                        {name: '领导成员', index: '2', routerName: 'member'},
                        {name: '协会章程', index: '3', routerName: 'constitution'},
                        {name: '组织机构图', index: '4', routerName: 'mechanism'},
                        {name: '联系方式', index: '5', routerName: 'contact'}
                    ]
                },
                {name: 'CMCA动态', index: '4', routerName: 'Policies', cId: '3'},
                {name: '政策法规', index: '5', routerName: 'Policies', cId: '4'},
                {name: '会议活动', index: '6', routerName: 'Policies', cId: '5'},
                {
                    name: '会员服务',
                    index: '7',
                    arr: [
                        {name: '入会须知', index: '1', routerName: 'membership'},
                        {name: '会员服务细则', index: '2', routerName: 'vipRule'},
                        {name: '申请表下载', index: '3', routerName: 'download'}
                    ]
                },
                {
                    name: '常设活动',
                    index: '8',
                    arr: [
                        {name: '教育与考试中心', index: '1', routerName: 'activities', cId: '4'},
                        {name: '区块链专业委员会', index: '2', routerName: 'activities', cId: '3'},
                        {name: '5G专业委员会', index: '3'},
                        {name: '移动数字医疗分会', index: '4', routerName: 'activities', cId: '6'},
                        {name: '虚拟现实产业专业委员会', index: '5', routerName: 'activities', cId: '7'},
                        {name: '视频直播委员会', index: '6', routerName: 'activities', cId: '8'},
                        {name: '安全扫码中心', index: '7', routerName: 'activities', cId: '9'}
                    ]
                }
                // {name: '市场监测', index: '9'}
                // {name: '证件查询', index: '10', routerName: 'certificateInquiry'}
            ]
        }
    },
    watch: {
        '$route.path': function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.state = this.$router.currentRoute.params.cId
            }
        }
    },
    mounted() {
        console.log(this.$router)
        console.log('this.navList', this.navList)
        this.state = this.$router.currentRoute.params.cId
    },
    methods: {
        drawerEvent() {
            this.drawer = true
        },
        select(index) {
            this.active = index
            if (typeof index === 'string') {
                let rootIndex = this.list[Number(index.split('-')[0]) - 1]// 根导航
                let second  = Number(index.split('-')[1]) - 1// 二级下标
                if (index.split('-').length > 1) { // 有二级
                    if (rootIndex.name === '常设活动') {
                        console.log(1)
                        console.log(rootIndex.arr[second].cId)
                        console.log(rootIndex.arr[second].routerName)
                        if (rootIndex.arr[second].cId) {
                            this.$router.push({
                                name: `${rootIndex.arr[second].routerName}`,
                                params: {
                                    id: rootIndex.arr[second].cId
                                }
                            })
                        } else {
                            location.href = 'https://www.ccia5g.org.cn/'
                        }
                        // this.activity.map(item => {
                        //     console.log('item.nmae==========', item.name)
                        //     if (item.name === rootIndex.arr[second].name) {
                        //         console.log('item.url==========', item.url)
                        //         location.href = item.url
                        //     }
                        // })
                        console.log('activity-list==========', this.activity)
                    } else if (rootIndex.arr[second].routerName) { // 下标
                        if (rootIndex.arr[second].cId) {
                            this.$router.push({
                                name: rootIndex.arr[second].routerName,
                                params: {
                                    cId: rootIndex.arr[second].cId
                                }
                            })
                        } else {
                            this.$router.push({
                                name: rootIndex.arr[second].routerName
                            })
                        }

                    }

                } else {
                    if (rootIndex.name == '市场监测') {
                        location.href = 'http://mc.cmca.org.cn/'
                    } else {
                        this.$router.push({name: `${rootIndex.routerName}`, params: {
                            cId: rootIndex.cId
                        }})
                        console.log(rootIndex.routerName)
                    }
                }
            }
            this.drawer = false
        }
    }
}
</script>

<style lang="scss" scoped>
//scss
::v-deep .el-drawer__body {
    overflow: auto;
}
.header {
    width: 100%;
    height: 57px;
    display: flex;
    justify-content: center;
    align-items: center;
    object-fit: cover;
    position: relative;
    background: url("../../../assets/images/index/di.png") no-repeat;
    background-size: 100% 100%;
    .logo {
        width: 200px;
        height: 35px;
    }
}
.nav {
    width: 19px;
    height: 19px;
    position: absolute;
    top: 17px;
    left: 20px;
}
.search {
    width: 19px;
    height: 19px;
    position: absolute;
    top: 17px;
    right: 20px;
}
::v-deep .el-menu-item.is-active {
    background: #243db3;
    color: #fff;
}
::v-deep .el-drawer__header {
    display: none;
}
</style>
